import { render, staticRenderFns } from "./FormMonedero.vue?vue&type=template&id=8f5be4de"
import script from "./FormMonedero.vue?vue&type=script&lang=js"
export * from "./FormMonedero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports